import request from '@/api/request'

export default {
  /**
   * Busca as contas cadastradas conforme filtros
   *
   * @param options
   * @returns {Promise<*>}
   */
  async getAccounts (options) {
    return (await request.get(`module/action/marketplace/tikTokShop/account/index`, {
      params: options
    })).data
  },
  /**
   * Retorna uma conta de acordo com o identificador
   *
   * @param identifier
   * @returns {Promise<*>}
   */
  async getAccountByIdentifier (identifier) {
    return (await request.get(`module/action/marketplace/tikTokShop/account/getOneById/${identifier}`)).data
  },
  /**
   * Retorna lista de lojas autorizadas de uma conta
   *
   * @param identifier
   * @returns {Promise<*>}
   */
  async getAuthorizedShops (identifier) {
    return (await request.get(`module/action/marketplace/tikTokShop/account/getAuthorizedShops/${identifier}`)).data
  },
  /**
   * Autentica a conta no marketplace
   *
   * @param code
   * @returns {Promise<*>}
   */
  async authenticate (code) {
    return (await request.get(`module/action/marketplace/tikTokShop/account/authenticate/${code}`)).data
  },
  /**
   * Realiza o refresh de um access_token de uma conta no marketplace manualmente
   *
   * @param identifier
   * @returns {Promise<*>}
   */
  async refreshTokenManually (identifier) {
    return (await request.get(`module/action/marketplace/tikTokShop/account/refreshTokenManually/${identifier}`)).data
  },
  /**
   * Atualiza o status da conta do TikTok Shop.
   *
   * @param {String} identifier
   * @param {Boolean} status
   * @returns {Object}
   */
  async updateAccountStatus (identifier, status) {
    if (status) {
      return (await request.get(`module/action/marketplace/tikTokShop/account/activate/${identifier}`)).data
    }

    return (await request.get(`module/action/marketplace/tikTokShop/account/deactivate/${identifier}`)).data
  },
    /**
   * Deleta uma conta de acordo com o identifier.
   *
   * @param identifier
   * @returns {Promise<*>}
   */
  async deleteAccount (identifier) {
    return (await request.get(`module/action/marketplace/tikTokShop/account/delete/${identifier}`)).data
  },
  /**
   * Retorna os centros dedistrbuição do tiktokshop, a partir de uma conta e uma loja autorizada.
   *
   * @param {string} accountIdentifier
   * @param {string} shopCipher
   * @returns {Promise.<Object>}
  */
  async getWarehouses (accountIdentifier, shopCipher) {
    return (await request.get(`module/action/marketplace/tikTokShop/warehouse/retrieve/${shopCipher}`, {
      headers: {
        'TikTokShop-Account': accountIdentifier
      }
    })).data
  },
  /**
   * Retorna as marcas do módulo.
   *
   * @param {string} accountIdentifier
   * @param {string} shopCipher
   * @param {string} keyword
   * @returns {Promise.<Object>}
  */
  async getCategories (accountIdentifier, shopCipher, keyword) {
    return (await request.get(`module/action/marketplace/tikTokShop/category/retrieve/${shopCipher}/${keyword.replace(/\s+/g, '_')}`, {
      headers: {
        'TikTokShop-Account': accountIdentifier
      }
    })).data
  },
  /**
   * Retorna as marcas do módulo.
   *
   * @param {string} accountIdentifier
   * @param {string} shopCipher
   * @param {string} categoryId
   * @returns {Promise.<Object>}
  */
  async getBrands (accountIdentifier, shopCipher, categoryId, brandKeyword) {
    return (await request.get(`module/action/marketplace/tikTokShop/brand/retrieve/${shopCipher}/${categoryId}/${brandKeyword.replace(/\s+/g, '_')}`, {
      headers: {
        'TikTokShop-Account': accountIdentifier
      }
    })).data
  },
  /**
   * Retorna as marcas do módulo.
   *
   * @param {string} accountIdentifier
   * @param {string} shopCipher
   * @param {string} categoryId
   * @returns {Promise.<Object>}
  */
  async getCategoryRules (accountIdentifier, shopCipher, categoryId) {
    return (await request.get(`module/action/marketplace/tikTokShop/category/getCategoryRules/${shopCipher}/${categoryId}`, {
      headers: {
        'TikTokShop-Account': accountIdentifier
      }
    })).data
  },
  /**
   * Retorna as guias de tamanho (size charts) registradas na loja
   *
   * @param {string} accountIdentifier
   * @returns {Promise.<Object>}
  */
  async getCategorySizeCharts (accountIdentifier) {
    return (await request.get(`module/action/marketplace/tikTokShop/category/getCategorySizeCharts`, {
      headers: {
        'TikTokShop-Account': accountIdentifier
      }
    })).data
  },
  /**
   * Retorna os atributos de uma categoria
   *
   * @param {string} accountIdentifier
   * @param {string} shopCipher
   * @param {string} categoryId
   * @returns {Promise.<Object>}
  */
  async getAttributes (accountIdentifier, shopCipher, categoryId) {
    return (await request.get(`module/action/marketplace/tikTokShop/attributes/retrieve/${shopCipher}/${categoryId}`, {
      headers: {
        'TikTokShop-Account': accountIdentifier
      }
    })).data
  },
  /**
   * Sincroniza pedido por tipo e identificador do módulo e conta do TikTok Shop.
   *
   * @param {String} type
   * @param {String} identifier
   * @param {String} code
   * @param {String} account
   * @param {string} shopCipher
   * @returns {Object} Pedido sincronizado
   */
  async syncOrder (type, identifier, code, account, shopCipher) {
    return (await request.get(`module/action/${type}/${identifier}/order/sync/${code}?shop_cipher=${shopCipher}`, {
      headers: {
        'TikTokShop-Account': account
      }
    })).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/tikTokShop/index.js